import { seedCustomers, seedInventoryMovements, seedOrders, seedProducts, seedSuppliers } from "@/data/seed";
import { Customer, InventoryMovement, Order, Product, Supplier } from "@/lib/types";

let products: Product[] = [...seedProducts];
let customers: Customer[] = [...seedCustomers];
let suppliers: Supplier[] = [...seedSuppliers];
let orders: Order[] = [...seedOrders];
let inventoryMovements: InventoryMovement[] = [...seedInventoryMovements];

export const store = {
    getProducts: () => products,
    addProduct: (product: Product) => {
        products = [product, ...products];
        return product;
    },

    getCustomers: () => customers,
    addCustomer: (customer: Customer) => {
        customers = [customer, ...customers];
        return customer;
    },

    getSuppliers: () => suppliers,
    addSupplier: (supplier: Supplier) => {
        suppliers = [supplier, ...suppliers];
        return supplier;
    },

    getOrders: () => orders,
    addOrder: (order: Order) => {
        orders = [order, ...orders];
        return order;
    },

    getInventoryMovements: () => inventoryMovements,
    addInventoryMovement: (movement: InventoryMovement) => {
        inventoryMovements = [movement, ...inventoryMovements];
        return movement;
    },
};